
const Loading = () =>{
    return (
        <div className='loading-indicator'>
            <p>Expanding the Graph...</p>
        </div>
    );
};

export default Loading;